export const APPLICATION_NAME = {
    digicedra: 'EA',
    digierp: 'DE',
    digicedrf: 'EF',
};

export const ENTITY_TYPE = {
    member: 'ADH',
    collab: 'CEDRE',
    supplier: 'FRN',
    vendor: 'VDR',
};
